export default __webpack_public_path__ + "static/media/matrix-inline-blue.783d3d49.svg";